import { render, staticRenderFns } from "./BusItemIssue.vue?vue&type=template&id=588707ae&scoped=true&"
import script from "./BusItemIssue.vue?vue&type=script&lang=js&"
export * from "./BusItemIssue.vue?vue&type=script&lang=js&"
import style0 from "./BusItemIssue.vue?vue&type=style&index=0&id=588707ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588707ae",
  null
  
)

export default component.exports